module.exports = __webpack_public_path__ + "img/plants-orange.fa1906d5.png";